import React, { Component } from 'react';
import { isWebUri } from 'valid-url';
import PointMapContainer from './containers/PointMap';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      urlInputValue: null,
      showWaypoints: false,
      loading: false,
      url: this.getUrl()
    };
  }

  getUrl() {
    const hash = window.location.hash;
    if (hash) {
      const parts = hash.split('url=');
      if (parts.length === 0) return;
      if (!isWebUri(parts[1])) return;

      return parts[1];
    }

    return null;
  }

  handleChange(event) {
    this.setState({ urlInputValue: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.state.urlInputValue) return;

    if (!isWebUri(this.state.urlInputValue)) {
      return alert("That doesn't look like a URL. Please try again!");
    }

    window.location = `#url=${this.state.urlInputValue}`;

    this.setState({ url: this.state.urlInputValue });
  }

  toggleWaypoints(event) {
    this.setState({ showWaypoints: event.target.checked });
  }

  toggleLoading() {
    this.setState({ loading: !this.state.loading });
  }

  setRouteName(name) {
    this.setState({ routeName: name });
  }

  render() {
    return (
      <div className="App">
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
          <div className="container">
            <a className="navbar-brand" href="/">
              <i className="fas fa-map mr-2" />
              GPX Viewer
            </a>
            <form
              className="form-inline"
              onSubmit={this.handleSubmit.bind(this)}
            >
              <input
                autoFocus
                className="form-control form-control-sm url-input mr-sm-2"
                type="search"
                placeholder="Enter the location of a GPX file"
                aria-label="Search"
                onChange={this.handleChange.bind(this)}
              />
              <button
                className="btn btn-sm btn-primary my-2 my-sm-0"
                type="submit"
              >
                {this.state.loading === true ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  'Load'
                )}
              </button>
            </form>
          </div>
        </nav>
        {!this.state.url ? (
          <>
            <div className="welcome">
              <div>
                <i className="fas fa-map-marked" />
                <div>Please enter a GPX file URL in the box above</div>
              </div>
            </div>
          </>
        ) : (
          <>
            {this.state.routeName && (
              <div className="sub p-2">
                <div className="container">
                  <div className="d-inline-block mr-4">
                    <strong>{this.state.routeName}</strong>
                  </div>
                  <div className="d-inline-block">
                    <div className="form-check">
                      <input
                        id="showWaypointsCheck"
                        type="checkbox"
                        className="form-check-input"
                        onChange={this.toggleWaypoints.bind(this)}
                        checked={this.state.showWaypoints}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="showWaypointsCheck"
                      >
                        Show Waypoint Markers
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div style={{ flex: 1, position: 'relative' }}>
              <PointMapContainer
                url={this.state.url}
                showWaypoints={this.state.showWaypoints}
                toggleLoading={this.toggleLoading.bind(this)}
                setRouteName={this.setRouteName.bind(this)}
              />
            </div>
            <div>
              <script id="mNCC" language="javascript">
                medianet_width = "728"; medianet_height = "20"; medianet_crid =
                "354700613"; medianet_versionId = "3111299";
              </script>
              <script src="//contextual.media.net/nmedianet.js?cid=8CUGY3850" />
            </div>
            <div className="footer p-2">
              <div className="container">
                Made with{' '}
                <span role="img" aria-label="heart">
                  💚
                </span>{' '}
                by <a href="https://twitter.com/tomhallam">@tomhallam</a>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default App;
